export default "__VITE_ASSET__BDFN3DFC__"